/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import {
  NavLink,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import qs from "qs";
import SearchIcon from "@mui/icons-material/Search";
import RestoreIcon from '@mui/icons-material/Restore';
import swal from "sweetalert";
import DeleteIcon from "@mui/icons-material/Delete";
import Collapse from '@mui/material/Collapse';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import CustomerCompanyFilter from "./CustomerCompanyFilter";
import {
  Alert,
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  Chip as MuiChip,
  Divider as MuiDivider,
  Grid,
  Link,
  Paper as MuiPaper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
  Modal,
  Checkbox,
  InputLabel,
  Autocomplete,
} from "@mui/material";
import { green, orange, red } from "@mui/material/colors";
import { Add as AddIcon, Download } from "@mui/icons-material";
import { spacing } from "@mui/system";
import { makeStyles, withStyles } from "@mui/styles";
import axios from "../../CustomAxios";
import Loading from "../components/Loading";
import { connect } from "react-redux";
import { CSVLink } from "react-csv";
import moment from "moment";

const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);

const useStyles = makeStyles({
  tableCell: {
    padding: "0px 12px 0px 0px",
    width: "1000px",
  },
});

const StyledTableContainer = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
}))(TableContainer);

const Chip = styled(MuiChip)`
  ${spacing};
  background: ${(props) => props.shipped && green[500]};
  background: ${(props) => props.processing && orange[700]};
  background: ${(props) => props.cancelled && red[500]};
  color: ${(props) => props.theme.palette.common.white};
`;

const Spacer = styled.div`
  flex: 1 1 100%;
`;

const ToolbarTitle = styled.div`
  min-width: 150px;
`;

function createData(
  id,
  name,
  email,
  mobile,
  address,
  prices,
  is_deleted
) {
  return {
    id,
    name,
    email,
    mobile,
    address,
    prices,
    is_deleted,
  };
}

const getCompanies = async (
  authData,
  setLoader,
  setRows,
  search,
  sortingField,
  sortingOrder,
  page,
  limit,
  setTotal,
  includeDeleted,
  plate_id
) => {
  try {
    setLoader(true);
    const config = {
      headers: {
        Authorization: "Bearer " + authData.access_token,
      },
    };
    const { data } = await axios.get(
      `/api/v1/${authData?.type}/customer_company/companies/plates/prices?sorting_field=${sortingField}&sorting_order=${sortingOrder}&search_keyword=${search}&page=${page + 1}&limit=${limit}&include_deleted=${includeDeleted ? "YES" : "NO"}&plate_id=${plate_id?._id}`,
      config
    );

    if (data.success) {
      const companies = data.data.data;
      setTotal(data.data.metadata.total_results);

      const rows = companies.map(company => {
        const address = company.address || "--";
        return createData(
          company._id,
          company.name,
          company.email_address,
          company.phone_number,
          `${address.address_line_one}, ${address.address_line_two}, ${address.city}, ${address.state}, ${address.pincode}`,
          company.price,
          company.is_deleted,
        );
      });
      setRows(rows);
      setLoader(false);
    }
  } catch (error) {
    console.log(error);
    setLoader(false);
  }
};

function Row(props) {
  const { row, viewPermission, editPermission, authData, auths, handleCompanyOperations, handleCompanyUpdate, headCells, plateHeadCells, openCreateModal, setOpenCreateModal, setSelectedCompany } = props;
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell align="left">{row.name}</TableCell>
        <TableCell align="left">{row.email}</TableCell>
        <TableCell align="left">{row.mobile}</TableCell>
        <TableCell align="left">{row.address}</TableCell>

        {/* {viewPermission && (
          <TableCell align="center">
            <VisibilityIcon
              style={{ cursor: "pointer", color: "green" }}
              onClick={() => navigate(`/dashboard/company/customer-companies/${row.id}`)}
            />
          </TableCell>
        )} */}

        {/* {editPermission && (
          <TableCell align="center">
            <EditIcon
              style={{ cursor: "pointer", color: "red" }}
              // onClick={() => navigate(`/dashboard/company/customer-companies/update/${row.id}`)}
            />
          </TableCell>
        )} */}

        {/* {(authData.type === "super_admin" || auths?.user?.role?.permissions.includes("delete_customer_company")) && (
          <TableCell align="center">
            {row.is_deleted ? (
              <Tooltip title="Restore">
                <RestoreIcon
                  style={{ cursor: "pointer", color: "green" }}
                  onClick={() => handleCompanyOperations(row.id)}
                />
              </Tooltip>
            ) : (
              <Tooltip title="Delete">
                <DeleteIcon
                  style={{ cursor: "pointer", color: "red" }}
                  onClick={() => handleCompanyOperations(row.id)}
                />
              </Tooltip>
            )}
          </TableCell>
        )} */}
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography variant="h6" gutterBottom marginY={4}>
                  Plate Prices
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setOpenCreateModal(true)
                    setSelectedCompany(row);
                  }
                  }
                >
                  Add Plate
                </Button>
              </Box>
              <Table size="small" aria-label="plate-prices">
                <TableHead>
                  <TableRow>
                    {plateHeadCells.map((cell) => (
                      <TableCell key={cell.label} align={cell.align}>
                        {cell.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody >
                  {row.prices.map((price, index) => (
                    <TableRow key={index} sx={{
                      '&:last-child td, &:last-child th': { borderBottom: 'none' },
                      backgroundColor: price?.deactivated ? "#eeaa9c" : "#fff",
                    }}>
                      <TableCell component="th" scope="row">
                        {`${price.plate?.height} x ${price.plate?.width} x ${price.plate?.thickness}`}
                      </TableCell>
                      <TableCell>{price.plate?.brand[0] || '-'}</TableCell>
                      <TableCell>{price.plate?.technology[0] || '-'}</TableCell>
                      <TableCell align="left">₹{price.baking_cost?.toLocaleString()}</TableCell>
                      <TableCell align="left">₹{price.print_cost?.toLocaleString()}</TableCell>
                      <TableCell align="left">₹{price.selling_cost?.toLocaleString()}</TableCell>
                      <TableCell align="left">₹{price.gripper?.toLocaleString()}</TableCell>
                      {(authData?.type === 'super_admin' || auths?.user?.role?.permissions.includes("customer_company_plate_list_update")) && <TableCell align="center">
                        <EditIcon
                          style={{ cursor: "pointer", color: "red" }}
                          onClick={() => {
                            handleCompanyUpdate(price, row);
                          }}
                        />
                      </TableCell>}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const EnhancedTableToolbar = (props) => {
  const {
    search,
    setSearch,
    setOnSearch,
    rows,
    csvPermission,
    navigate,
    sortingField,
    sortingOrder,
    setSortingField,
    setSortingOrder,
    includeDeleted,
    setIncludeDeleted,
    setFilter,
    plateList,
    setPlateId,
    plate_id,
  } = props;

  const csvReport = {
    filename: `Customer_Companies_Plates_${moment().format("DD-MM-YY_HHmm")}.csv`,
    headers: [
      { label: "Company Name", key: "name" },
      // { label: "Email", key: "email" },
      // { label: "Phone", key: "mobile" },
      // { label: "Address", key: "address" },
      { label: "Plate Details", key: "plate_details" },
      { label: "Brand", key: "brand" },
      { label: "Technology", key: "technology" },
      { label: "Baking Cost", key: "baking_cost" },
      { label: "Print Cost", key: "print_cost" },
      { label: "Selling Cost", key: "selling_cost" },
      { label: "Gripper", key: "gripper" },
    ],
    data: rows.flatMap(row =>
      row.prices.map(price => ({
        ...row,
        plate_details: `${price.plate?.height}x${price.plate?.width}x${price.plate?.thickness}`,
        brand: price.plate?.brand[0] || '',
        technology: price.plate?.technology[0] || '',
        baking_cost: price.baking_cost,
        print_cost: price.print_cost,
        selling_cost: price.selling_cost,
        gripper: price.gripper
      }))
    ),
  };

  return (
    <form onSubmit={(e) => {
      e.preventDefault();
      setOnSearch(prev => !prev);
    }}>
      <Toolbar>
        <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"} width={"100%"}>
          <Typography variant="h6" >Companies</Typography>
          <Box display={"flex"} alignItems={"center"} gap={2}>


            <CSVLink {...csvReport} style={{ textDecoration: 'none' }}>
              <Button variant="outlined" endIcon={<Download />}>
                Export CSV
              </Button>
            </CSVLink>

            <TextField
              size="small"
              variant="outlined"
              label="Search"
              placeholder="Name/Email/Phone"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              sx={{ mx: 2, width: 600 }}
            />

            <Button
              type="submit"
              variant="contained"
              color="primary"
              endIcon={<SearchIcon />}
            >
              Search
            </Button>
            <CustomerCompanyFilter
              setFilter={setFilter}
              sortingField={sortingField}
              sortingOrder={sortingOrder}
              setSortingField={(value) =>
                setSortingField(value === "" ? "updated_at" : value)
              }
              setSortingOrder={(value) =>
                setSortingOrder(value === "" ? "desc" : value)
              }
              includeDeleted={includeDeleted}
              setIncludeDeleted={setIncludeDeleted}
              plateList={plateList}
              setPlateId={setPlateId}
              plate_id={plate_id}
              show={true}
            />
          </Box>
        </Box>
      </Toolbar>
    </form>
  );
};

const CreatePlateModal = ({
  open,
  onClose,
  selectedCompany,
  onCreateSuccess,
  inventory,
}) => {
  const [loading, setLoading] = useState(false);
  const [bakingCost, setBakingCost] = useState(0);
  const [printCost, setPrintCost] = useState(0);
  const [sellingCost, setSellingCost] = useState(0);
  const [gripper, setGripper] = useState(0);
  const [deactivated, setDeactivated] = useState(false);
  const [plate, setPlate] = useState(null);
  const [plate_id, setPlateId] = useState(null);
  const authData = JSON.parse(localStorage.getItem("AuthData"));
  const config = {
    headers: {
      Authorization: "Bearer " + authData.access_token,
    },
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const plate = {
      plate_id: plate_id,
      baking_cost: Number(bakingCost),
      print_cost: Number(printCost),
      selling_cost: Number(sellingCost),
      gripper: Number(gripper),
      deactivated: deactivated,
    }
    try {
      setLoading(true);
      const res = await axios.post(`/api/v1/${authData.type}/customer_company/${selectedCompany.id}/plates/prices`,
        { plate },
        config
      );
      onCreateSuccess();
      onClose();
    } catch (error) {
      console.error("Create failed:", error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Paper sx={{ padding: "2%", width: "40vw" }}>
      <Typography variant="h6" gutterBottom marginBottom={8}>
        Add Plate - {selectedCompany?.name}
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6} >
            <Autocomplete
              name="plate"
              id="plate"
              options={inventory}
              value={plate}
              onChange={(e, value) => {
                setPlate(value);
                setPlateId(value?._id || null);
              }}
              getOptionLabel={(option) =>
                option ? `${option.height}x${option.width}x${option.thickness} || ${option?.technology?.name}` : ""
              }
              isOptionEqualToValue={(option, value) => option._id === value._id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Plate"
                  variant="outlined"
                />
              )}
            />

          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Baking Cost"
              variant="outlined"
              value={bakingCost}
              onChange={(e) =>
                setBakingCost(e.target.value)
              }
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Print Cost"
              variant="outlined"
              value={printCost}
              onChange={(e) =>
                setPrintCost(e.target.value)
              }
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Selling Cost"
              variant="outlined"
              value={sellingCost}
              onChange={(e) =>
                setSellingCost(e.target.value)
              }
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Gripper"
              variant="outlined"
              value={gripper}
              onChange={(e) =>
                setGripper(e.target.value)
              }
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} display={"flex"} gap={1} alignItems={"center"}>
            <Checkbox
              checked={deactivated}
              onChange={(e) => setDeactivated(e.target.checked)}
              name="deactivated"
              color="primary"
            />
            <InputLabel htmlFor="deactivated" sx={{ fontSize: 14, fontWeight: 600 }}>DELETE</InputLabel>
          </Grid>
          <Grid item xs={12} display={"flex"} justifyContent={"flex-end"}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={loading}
            >
              {loading ? "Creating..." : "Create"}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  )

};

const UpdatePlateModal = ({
  open,
  onClose,
  selectedPlate: initialPlate,
  selectedCompany,
  onUpdateSuccess,
}) => {
  const [loading, setLoading] = useState(false);
  const [plateData, setPlateData] = useState(initialPlate);
  const [deactivated, setDeactivated] = useState(plateData?.deactivated);
  const authData = JSON.parse(localStorage.getItem("AuthData"));
  const config = {
    headers: {
      Authorization: "Bearer " + authData.access_token,
    },
  };

  // Sync local state when props change
  useEffect(() => {
    setPlateData(initialPlate);
  }, [initialPlate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const plate = {
      baking_cost: plateData?.baking_cost === "" ? 0 : Number(plateData?.baking_cost),
      print_cost: plateData?.print_cost === "" ? 0 : Number(plateData?.print_cost),
      selling_cost: plateData?.selling_cost === "" ? 0 : Number(plateData?.selling_cost),
      gripper: plateData?.gripper === "" ? 0 : Number(plateData?.gripper),
      plate_id: plateData?.plate_id,
      deactivated: deactivated,
    }

    try {
      setLoading(true);
      const response = await axios.put(
        `/api/v1/${authData.type}/customer_company/${selectedCompany.id}/plates/prices`,
        { plate },
        config
      );
      if (response.data.success) {
        onUpdateSuccess();
        onClose();
      }
    } catch (error) {
      console.error("Update failed:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper sx={{ padding: "2%", width: "40vw" }}>
      <Typography variant="h6" gutterBottom marginBottom={8}>
        Update Prices - {selectedCompany?.name}
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6} >
            <TextField
              label="Plate Details"
              variant="outlined"
              value={`${plateData?.plate?.height}x${plateData?.plate?.width}x${plateData?.plate?.thickness} || ${plateData?.plate?.technology[0]}` || ""}
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Baking Cost"
              variant="outlined"
              value={plateData?.baking_cost || ""}
              onChange={(e) =>
                setPlateData({
                  ...plateData,
                  baking_cost: e.target.value,
                })
              }
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Print Cost"
              variant="outlined"
              value={plateData?.print_cost || ""}
              onChange={(e) =>
                setPlateData({
                  ...plateData,
                  print_cost: e.target.value,
                })
              }
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Selling Cost"
              variant="outlined"
              value={plateData?.selling_cost || ""}
              onChange={(e) =>
                setPlateData({
                  ...plateData,
                  selling_cost: e.target.value,
                })
              }
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Gripper"
              variant="outlined"
              value={plateData?.gripper || ""}
              onChange={(e) =>
                setPlateData({
                  ...plateData,
                  gripper: e.target.value,
                })
              }
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} display={"flex"} gap={1} alignItems={"center"}>
            <Checkbox
              checked={deactivated}
              onChange={(e) => setDeactivated(e.target.checked)}
              name="deactivated"
              color="primary"
            />
            <InputLabel htmlFor="deactivated" sx={{ fontSize: 14, fontWeight: 600 }}>DELETE</InputLabel>
          </Grid>
          <Grid item xs={12} display={"flex"} justifyContent={"flex-end"}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={loading}
            >
              {loading ? "Updating..." : "Update"}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

function CustomerCompanyPlates({ auths }) {
  const authData = JSON.parse(localStorage.getItem("AuthData"));
  const [loader, setLoader] = useState(true);
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [search, setSearch] = useState('');
  const [sortingField, setSortingField] = useState('updated_at');
  const [sortingOrder, setSortingOrder] = useState('desc');
  const [includeDeleted, setIncludeDeleted] = useState(false);
  const [filter, setFilter] = useState(false);
  const [onSearch, setOnSearch] = useState(false);
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [selectedPlate, setSelectedPlate] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const navigate = useNavigate();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [editPermission, setEditPermission] = useState(false);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [inventory, setInventory] = useState([]);
  const [plate, setPlate] = useState({});
  const [plateList, setPlateList] = useState([]);
  const [plate_id, setPlateId] = useState(null);
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  useEffect(() => {
    const fetchInventory = async () => {
      try {
        const authData = JSON.parse(localStorage.getItem("AuthData"));
        const config = {
          headers: {
            Authorization: "Bearer " + authData.access_token,
          },
        };
        const data = await axios.get(
          `/api/v1/${authData?.type}/plate_inventory?page=1&limit=200`,
          config
        );
        setInventory(data?.data?.data?.data);
        setPlateList(data?.data?.data?.data);

      } catch (error) {
        console.log(error);
      }
    };
    fetchInventory();
  }, []);

  useEffect(() => {
    if (authData.type === 'super_admin' || auths?.user?.role?.permissions.includes("customer_company_plate_list_update")) {
      setEditPermission(true);
    } else {
      setEditPermission(false);
    }
  })

  const handleCompanyOperations = async (id) => {
    try {
      setLoader(true);
      const response = await axios.delete(
        `/api/v1/${authData.type}/customer_company/${id}/delete`,
        { headers: { Authorization: `Bearer ${authData.access_token}` } }
      );
      if (response.data.success) {
        setFilter(true);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.error('Operation failed:', error);
    }
  };

  const handleUpdateSuccess = () => {
    setFilter((prev) => !prev);
  };

  const handleCompanyUpdate = async (plate, company) => {
    setSelectedPlate(plate);
    setSelectedCompany(company);
    setOpenUpdateModal(true);
  };

  const headCells = [
    { key: "expand", alignment: "left", label: "" },
    { key: "name", alignment: "left", label: "Company Name" },
    { key: "email", alignment: "left", label: "Email" },
    { key: "mobile", alignment: "left", label: "Phone Number" },
    { key: "address", alignment: "left", label: "Address" },
  ];

  const plateHeadCells = [
    { label: "Plate Details", align: "left" },
    { label: "Brand", align: "left" },
    { label: "Technology", align: "left" },
    { label: "Baking Cost", align: "left" },
    { label: "Print Cost", align: "left" },
    { label: "Selling Cost", align: "left" },
    { label: "Gripper", align: "left" },
    editPermission && { label: "Edit", align: "center" },
  ];

  useEffect(() => {
    const params = {
      page: page + 1,
      limit: rowsPerPage,
      search_keyword: search,
      sorting_field: sortingField,
      sorting_order: sortingOrder,
      include_deleted: includeDeleted ? 'YES' : 'NO'
    };

    navigate(`?${qs.stringify(params)}`, { replace: true });
    getCompanies(authData, setLoader, setRows, search, sortingField,
      sortingOrder, page, rowsPerPage, setTotal, includeDeleted, plate_id);

    // Reset filter state after fetching
    setFilter(false);
    setOnSearch(false);
  }, [page, rowsPerPage, filter, onSearch]);

  if (loader) return <Loading />;

  return (
    <React.Fragment>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Typography
        variant="h4"

        sx={{ fontWeight: 600 }}
        color="primary"
        marginBottom={4}
        marginTop={2}
      >
        CUSTOMER COMPANIES
      </Typography>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Paper sx={{ padding: 2 }}>
            <EnhancedTableToolbar
              search={search}
              setSearch={setSearch}
              setOnSearch={setOnSearch}
              rows={rows}
              csvPermission={authData?.type === 'super_admin'}
              navigate={navigate}
              sortingField={sortingField}
              sortingOrder={sortingOrder}
              setSortingField={setSortingField}
              setSortingOrder={setSortingOrder}
              includeDeleted={includeDeleted}
              setIncludeDeleted={setIncludeDeleted}
              setFilter={setFilter}
              plateList={plateList}
              setPlateId={setPlateId}
              plate_id={plate_id}
            />

            <StyledTableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    {headCells.map((cell) => (
                      <TableCell key={cell.key} align={cell.alignment}>
                        {cell.label}
                      </TableCell>
                    ))}
                    {/* <TableCell align="center">Actions</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <Row
                      key={row.id}
                      row={row}
                      viewPermission={authData.type === 'super_admin'}
                      editPermission={authData.type === 'super_admin'}
                      authData={authData}
                      auths={auths}
                      handleCompanyOperations={handleCompanyOperations}
                      handleCompanyUpdate={handleCompanyUpdate}
                      headCells={headCells}
                      plateHeadCells={plateHeadCells}
                      openCreateModal={openCreateModal}
                      setOpenCreateModal={setOpenCreateModal}
                      setSelectedCompany={setSelectedCompany}
                    />
                  ))}
                </TableBody>
              </Table>
            </StyledTableContainer>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              component="div"
              count={total}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </Grid>
      </Grid>
      {openUpdateModal && <Modal open={openUpdateModal} onClose={() => setOpenUpdateModal(false)} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <UpdatePlateModal
          open={openUpdateModal}
          onClose={() => setOpenUpdateModal(false)}
          selectedPlate={selectedPlate}
          selectedCompany={selectedCompany}
          onUpdateSuccess={() => {
            setFilter(prev => !prev);
            handleSnackbarOpen("Plate prices updated successfully!", "success");
          }}
          onError={(message) => handleSnackbarOpen(message, "error")}
        />
      </Modal>}
      {openCreateModal && <Modal open={openCreateModal} onClose={() => setOpenCreateModal(false)} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CreatePlateModal
          open={openCreateModal}
          onClose={() => setOpenCreateModal(false)}
          selectedCompany={selectedCompany}
          onCreateSuccess={() => {
            setFilter(prev => !prev);
            handleSnackbarOpen("Plate prices updated successfully!", "success");
          }}
          setPlate={setPlate}
          inventory={inventory}
          plate={plate}
        />
      </Modal>}
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps)(CustomerCompanyPlates);